/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon16Solid = forwardRef('MathSumIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.347 4.745C2.227 3.82 2.881 2 4.334 2H12.5a1.25 1.25 0 1 1 0 2.5H6.976l2.79 2.305c.75.62.75 1.77 0 2.39L6.976 11.5H12.5a1.25 1.25 0 1 1 0 2.5H4.334c-1.453 0-2.107-1.82-.987-2.745L7.287 8l-3.94-3.255Z" })));
});
